export default "__VITE_ASSET__DLTEhOqk__"